<script>
export default {
  name: 'BookingConfirmationListSkeleton',
}
</script>

<template>
  <section>
    <header class="d-flex align-center justify-space-between">
      <p class="text-h6 text--primary">Confirmations</p>
      <v-btn small color="blue" class="cl-elevation white--text mb-2" disabled>
        <v-icon left>mdi-plus</v-icon> Add
      </v-btn>
    </header>
    <article>
      <v-skeleton-loader
        v-for="i of 4"
        :key="`booking-confirmation-list-skeleton-${i}`"
        class="rounded-xl cl-elevation mb-2"
        type="list-item-avatar-three-line"
      ></v-skeleton-loader>
    </article>
  </section>
</template>
